module.exports = new __parcel__URL__("mining_back_to_homebase_button.29feb859.png").toString();